module.exports = __webpack_public_path__ + "media/img/history_image-a87feaa3.png";